// extracted by mini-css-extract-plugin
module.exports = {"completeProfilePage":"CompleteProfilePage_completeProfilePage__10qW9","completeProfileBlock":"CompleteProfilePage_completeProfileBlock__1r68P"};